import React, { useMemo } from 'react';
import { educationData } from '../../../data/educationData';
import { experienceData } from '../../../data/experienceData';
import { buildTimeline } from '../../../utils/timeline';

// Bars narrower than this share of the axis put their label beside the bar.
const SHORT = 0.3;

function Timeline() {
    const { items, from, to, lanes, ticks } = useMemo(
        () => buildTimeline({ experience: experienceData, education: educationData }),
        []
    );
    if (items.length === 0) return null;

    const span = to - from;
    const pct = (year) => `${((year - from) / span) * 100}%`;

    return (
        <figure className='timeline'>
            <figcaption className='timeline__caption'>
                Career at a glance, {from} to {to > new Date().getFullYear() ? 'today' : to}
            </figcaption>
            <div className='timeline__chart' style={{ '--lanes': lanes, '--years': span }}>
                <div className='timeline__axis' aria-hidden='true'>
                    {ticks.map((year) => (
                        <span key={year} style={{ left: pct(year) }}>{year}</span>
                    ))}
                </div>
                <ul className='timeline__bars'>
                    {items.map((item) => (
                        <li
                            key={item.id}
                            className={`timeline__bar timeline__bar--${item.kind.toLowerCase()}${(item.end - item.start) / span < SHORT ? ' is-short' : ''}${(item.end - from) / span > 0.5 ? ' is-late' : ''}`}
                            title={`${item.title}, ${item.sub}, ${item.period}`}
                            style={{ left: pct(item.start), width: `calc(${pct(item.end)} - ${pct(item.start)})`, '--lane': item.lane }}
                        >
                            <span className='timeline__label'>
                                <strong>{item.title}</strong>
                                <span className='sr-only'>, {item.sub}, {item.period}</span>
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
            <p className='timeline__legend' aria-hidden='true'>
                <span className='timeline__swatch timeline__swatch--role' /> Work
                <span className='timeline__swatch timeline__swatch--education' /> Education
            </p>
        </figure>
    );
}

export default Timeline;
